import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class PshipCodeMastService {

  constructor(private http: HttpClient) { }

  /**
   * Save Partnership Code Master Record
   * @param baseUrl - Base URL from GENERAL_CONFIG
   * @param clobSettings - Settings object with sso_id
   * @param clobData - Data object with code master details
   * @param globalService - Global service data
   * @param filterParams - Filter parameters from AngularJS
   * @param rowData - Row data from AngularJS
   */
  saveACodeMastRecord(
    baseUrl: string,
    clobSettings: any,
    clobData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🔴 CRITICAL: Build URL with action_code
    const url = `${baseUrl}/saveJsonObject?action_code=cxka0b`;
    
    // 🔴 CRITICAL: Build payload EXACTLY like original AngularJS
    let params: any = {};
    
    // Add clob_data and clob_settings (note: singular "clob_settings" not "clob_setting")
    params.clob_data = JSON.stringify(clobData);
    params.clob_settings = JSON.stringify(clobSettings);
    
    // Add process_name and sso_id
    params.process_name = "Partnership Code Mast Save";
    params.sso_id = clobSettings.sso_id;
    
    console.log('Service params = ', params);
    
    // 🔴 CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    return this.http.post<any>(url, urlEncoded.toString(), { 
      headers, 
      withCredentials: true 
    });
  }
}

